import Vue from "vue";

import VueRouter from "vue-router";

import Attendees from "../views/Attendees.vue";
import CheckIn from "../views/CheckIn.vue";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Meetings from "../views/Meetings.vue";
import Register from "../views/Register.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/meetings",
    name: "meetings",
    component: Meetings
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/checkin/:userID/:meetingID",
    name: "checkin",
    component: CheckIn
  },
  {
    path: "/attendees/:userID/:meetingID",
    name: "attendees",
    component: Attendees
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
